import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";
import styles from "./ClientsTooltipWrapper.module.scss";

interface Props {
  name: string | null | undefined;
}

export function ClientsTooltipWrapper(props: Props) {
  if (!props.name) return null;
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className={styles.name}>{props.name}</div>
      </TooltipTrigger>
      <TooltipContent className={styles.tooltipContent}>
        {props.name}
      </TooltipContent>
    </Tooltip>
  );
}
